import React, { useState, useEffect } from "react";
import "./scss/project-management.scss";
import { PROJECT_MANAGEMENT } from "../../constants/route-paths";
import {
  getProjectList as getProjectListAction,
  editProject as editProjectAction,
  deleteProject as deleteProjectAction,
  saveTemplate as saveTemplateAction,
  duplicateProject as duplicateProjectAction,
  downloadMaterialSummary as downloadMaterialSummaryAction,
  bulkMaterialUpdate as bulkMaterialUpdateAction,
  getvendorsPOInvoiceCount,
} from "../../actions/project-management.action";
import { getCustomerList } from "../../actions/customer-management.action";
import { useDispatch, useSelector } from "react-redux";
import { verifyPassword } from "../../actions/user-management.action";
import { successSnackBar, infoSnackBar } from "../../actions/common.action";
import { format } from "date-fns";
import { PROJECT_STATUS, PROJECT_TYPE } from "../../util/enums";
import DeleteDialog from "../../components/delete-dialog";
import { Menu, MenuItem } from "@material-ui/core";
import { updateProjectAction, addOverviewCardsAction } from "../../slice/project-summary";
import Modal from "../../components/modal/modal";
import AddProject from "./add-project";
import AddTemplate from "./add-template-modal";
import ChangeProjectStatus from "./change-project-status";
import DuplicateProjectDialog from "../../components/duplicate-project-dialog";
import { getProjectType } from "./utils/getProjectStatus";
import { ValidateField } from "../../util/validators";
import { projectListPasswordField } from "./project-list/password-field";
import CustomInput from "../../components/inputs/new-input";
import _ from "lodash";
import { updateProjectSummaryData, getProjectSummaryData } from "./utils/get-project-summary";
import idx from "idx";
import UploadCostModal from "../../components/upload-cost-modal";
import { useLocation } from "react-router-dom";

function ProjectMenu(props) {
  const {
    anchorEl,
    projectId,
    type,
    menuType,
    projectType,
    writePermission,
    history,
    onClose,
  } = props;

  const [deleteopen, setdeleteopen] = useState(false);
  const [deleteId, setdeleteId] = useState("");
  const [changeStatusDialog, setchangeStatusDialog] = useState(false);
  const [newStatus, setnewStatus] = useState("");
  const [showTemplateModal, setshowTemplateModal] = useState("");
  const [showDuplicateDialog, setshowDuplicateDialog] = useState(false);
  const [customersList, setcustomersList] = useState([]);
  const [viewProjectOpen, setviewProjectOpen] = useState(false);
  const [confirmPasswordOpen, setConfirmPasswordOpen] = useState(false);
  const [uploadCostOpen, setUploadCostOpen] = useState(false);
  const [projectToDeleteId, setProjectToDeleteId] = useState("");
  const location = useLocation();

  useEffect(() => {
    if (location.state?.openUploadCostModal) {
      setUploadCostOpen(true);
    }
  }, [location.state]);

  const [menuState, setMenuState] = useState({
    ...JSON.parse(JSON.stringify(projectListPasswordField)),
  });
  const dispatch = useDispatch();
  const entitlements = useSelector((state) => state.user.entitlements);
  const projectSummary = useSelector((state) => state.projectSummary);
  const [hasAttributionEnabled, setHasAttributionEnabled] = useState(false);

  const templateModalHandler = (status) => {
    setshowTemplateModal(status);
  };

  const handleClose = () => {
    onClose({ anchorEl: null, hasStages: null });
  };
  // const handleMenu = (event, projectId, hasStages, projectName) => {
  //   history({ anchorEl: event.currentTarget, projectId, hasStages, projectName });
  // };
  const assetDialogHandler = () => {
    history(`/projects/asset/${props.projectId}`);
  };
  // const addProject = () => {
  //   history(`/${PROJECT_MANAGEMENT}/${ADD_PROJECT}?project-type=${projectType}`)
  // }

  const editProject = (id = null) => {
    if (!id) {
      id = props.projectId;
    }
    history(`/${PROJECT_MANAGEMENT}/edit/${id}`);
  };

  const reviseProject = (id = null) => {
    if (!id) {
      id = props.projectId;
    }

    history(`/${PROJECT_MANAGEMENT}/edit/${id}?action=revise`);
    if (props.projectStepTwo) {
      window.location.reload(); // Refresh the page
    }
  };

  const updatePricing = () => {
    handleClose();
    dispatch(bulkMaterialUpdateAction({
      projectIds: [props.projectId],
      updateFromCatalog: true,
      createRevision: true
    })).then(res => {
      // Check if revisions were created
      if (res?.revisions && res.revisions.length > 0) {
        const newRevision = res.revisions.find(r => r.originalProjectId === props.projectId);

        if (menuType === "View" && newRevision && newRevision.newRevisionProjectId) {
          // Rule 2: From summary page, redirect to the new revision
          dispatch(successSnackBar('New project revision created with updated pricing. Redirecting...'));
          history(`/projects/view/tender/${newRevision.newRevisionProjectId}`);
          return;
        } else {
          // Rule 1: Stay on page and show success
          dispatch(successSnackBar('New project revision created with updated pricing.'));
        }
      } else {
        // Check for warnings if no revision was created
        const noChangeWarning = (res?.warnings || []).find(w => w.type === 'NO_CHANGES');
        if (noChangeWarning) {
          dispatch(infoSnackBar(`No pricing changes detected for ${noChangeWarning.name || 'this project'}. Revision creation skipped.`));
        } else {
          dispatch(successSnackBar('Pricing updated successfully.'));
        }
      }

      // Refresh the project list/data
      getProjetcList();

      // If we are in View mode, we might need to refresh the summary data specifically
      if (menuType === "View") {
        updateProjectSummaryData({ projectId: props.projectId, dispatch });
      }
    });
  };

  const saveTemplate = (data) => {
    templateModalHandler(false);
    let hasStages = props.hasStages;
    let projectId = props.projectId;
    dispatch(
      saveTemplateAction({
        ...data,
        projectId,
        hasStages,
      }),
    )
      .then((res) => {
        if (menuType == "View") {
          history(`/projects?project-type=${projectType}`);
        }
      })
      .catch((err) => templateModalHandler(true));
    handleClose();
  };

  const deleteHandler = (id = "") => {
    markAsDeleted();
    setProjectToDeleteId(props.projectId);
    deleteDialogHandler(props.projectId);
  };

  const formateObj = (project) => {
    return {
      id: project.id,
      tenderNumber: project.tenderNumber,
      projectName: project.name,
      customer: project.customer && project.customer.business_name,
      address: project.address,
      quotetype: project.projectQuoteType,
      status: project.status,
      reasonOfLost: project.reasonOfLost,
      rootProjectId: project.rootProjectId,
      hasStages: project.hasStages,
      createdAt: format(new Date(project.dateOfCreation), "dd/MM/yyyy"),
      dateOfDLP: project.dateOfDLP
        ? format(new Date(project.dateOfDLP), "dd/MM/yyyy")
        : "",
    };
  };

  const getProjetcList = () => {
    const projectList = [];
    const tender = [];
    const dlp = [];
    const completed = [];
    const archived = [];
    dispatch(getProjectListAction("", "", "", projectType)).then((projects) => {
      projects.forEach((project) => {
        let { isCurrent, isQuote, isDLP, isCompleted, isArchived } =
          getProjectType(project);
        if (isCurrent) {
          projectList.push(formateObj(project));
        } else if (isQuote) {
          tender.push(formateObj(project));
        } else if (isArchived) {
          archived.push(formateObj(project));
        } else if (isCompleted) {
          completed.push(formateObj(project));
        } else if (isDLP) {
          dlp.push(formateObj(project));
        }
      });
      const projectsCount = {
        totalProjects: projectList.length,
        totalTenders: tender.length,
        totalDLP: dlp.length,
        totalArchived: archived.length,
        totalCompleted: completed.length,
      };
      let _state = {
        projectsCount,
        project: projectList,
        tender,
        dlp,
        completed,
        archived,
      };
      history(_state);
    });
  };

  const deleteDialogHandler = (id = "") => {
    // handleClose()
    setdeleteopen(!deleteopen);
    setdeleteId(id);
    setMenuState({
      ...menuState,
      password: { ...menuState.password, value: "" },
    });
  };

  const handleViewProjectClose = () => {
    const dialogState = viewProjectOpen;
    setviewProjectOpen(!dialogState);
    if (dialogState) {
      handleClose();
      getProjetcList();
    } else {
      // Fetch project summary when opening the modal
      if (projectId) {
        updateProjectSummaryData({ projectId, dispatch }).then(() => {
          // Check if any section has attribution enabled
          // The sectionData in Redux store contains the processed stages
          // Let's check the sectionData which should have the attribution info

          const sectionData = idx(projectSummary, (_) => _.sectionData) || [];

          if (Array.isArray(sectionData) && sectionData.length > 0) {
            // Recursive function to check all stages for attribution
            const checkAttributionInStages = (stages) => {
              let hasAttribution = false;

              stages.forEach(stage => {
                if (stage.is_attribution_level === true) {
                  hasAttribution = true;
                }

                // Check nested stages
                if (stage.stages && Array.isArray(stage.stages)) {
                  if (checkAttributionInStages(stage.stages)) {
                    hasAttribution = true;
                  }
                }
              });

              return hasAttribution;
            };

            const hasAttribution = checkAttributionInStages(sectionData);
            setHasAttributionEnabled(hasAttribution);
          } else {
            // Fallback: fetch from project list
            dispatch(getProjectListAction("", "", "", "TENDER")).then(projects => {
              const currentProject = projects.find(p => p.id === projectId);
              if (currentProject && currentProject.stages) {

                const checkAttributionInStages = (stages) => {
                  let hasAttribution = false;
                  stages.forEach(stage => {
                    if (stage.is_attribution_level === true) {
                      hasAttribution = true;
                    }
                    if (stage.stages && Array.isArray(stage.stages)) {
                      if (checkAttributionInStages(stage.stages)) {
                        hasAttribution = true;
                      }
                    }
                  });
                  return hasAttribution;
                };

                const hasAttribution = checkAttributionInStages(currentProject.stages);
                setHasAttributionEnabled(hasAttribution);
              } else {
                setHasAttributionEnabled(false);
              }
            }).catch(err => {
              console.error('Error fetching project list:', err);
              setHasAttributionEnabled(false);
            });
          }
        }).catch(err => {
          console.error('Error fetching project summary:', err);
        });
      }
    }
  };

  // const viewProject = () => {
  //   const id = props.projectId
  //   history(`/${PROJECT_MANAGEMENT}/view/${id}`)
  // }

  // const clostAsLost = () => {
  //   setnewStatus('LOST')
  //   handleClose()
  //   changeStatusHandler()
  //   getProjetcList()
  // }

  const changeStatus = (data) => {
    dispatch(editProjectAction(data, props.projectId)).then((res) => {
      changeStatusHandler();
      getProjetcList();
      if (menuType == "List") {
        props.changeProjectType(newStatus);
      }
      if (menuType == "View") {
        dispatch(updateProjectAction({ status: newStatus || data.status }));
        history(`/projects?project-type=${projectType}`);
      }
    });
  };

  const markAsDLP = () => {
    setnewStatus(PROJECT_STATUS.DLP);
    setchangeStatusDialog(!changeStatusDialog);
    if (changeStatusDialog) handleClose();
    // changeStatusHandler()
    // getProjetcList()
  };

  const markAsCompleted = () => {
    handleClose();
    dispatch(editProjectAction({ status: PROJECT_STATUS.COMPLETED }, props.projectId)).then(
      (res) => {
        if (menuType == "List") {
          props.changeProjectType(newStatus);
        }
      },
    );
  };

  // const markAsCancelled = () => {
  //   setnewStatus('CANCELLED')
  //   handleClose()
  //   changeStatusHandler()
  //   getProjetcList()
  // }

  const markAsArchived = () => {
    setnewStatus(PROJECT_STATUS.ARCHIVED);
    setchangeStatusDialog(!changeStatusDialog);
    // changeStatusHandler()
    if (changeStatusDialog) handleClose();

    // getProjetcList()
  };

  const markAsInProgress = () => {
    handleClose();
    dispatch(
      editProjectAction({ status: PROJECT_STATUS.IN_PROGRESS }, props.projectId),
    ).then((res) => {
      if (menuType == "List") {
        getProjetcList();
        props.changeProjectType(newStatus);
      }
    });
  };

  const markAsSubmit = () => {
    handleClose();
    dispatch(
      editProjectAction({ status: PROJECT_STATUS.TENDER_SUBMITTED }, props.projectId),
    ).then((res) => {
      if (menuType == "List") {
        getProjetcList();
        props.changeProjectType(newStatus || PROJECT_STATUS.TENDER_SUBMITTED);
      }
      if (menuType == "View") {
        dispatch(updateProjectAction({ status: PROJECT_STATUS.TENDER_SUBMITTED }));
      }
    });
  };

  const markAsDeleted = () => {
    // handleClose()
    setConfirmPasswordOpen(true);
  };

  const inputPasswordChangeHandler = (e) => {
    let password = menuState.password;
    var value;
    if (_.isObject(e)) {
      value = e.target.value;
    }

    password.value = value;
    password.touched = true;
    const { error, valid } = ValidateField({
      value,
      validation: password.validation,
    });
    password.error = error;
    password.valid = valid;
    setMenuState({ ...menuState, password });
  };

  const verifyUserPassword = () =>
    dispatch(verifyPassword(menuState.password.value))
      .then((res) => {
        return true;
      })
      .catch((err) => {
        throw new Error(err);
      });

  const handlePasswordVerification = async () => {
    const { password } = menuState;
    let isPasswordFieldValid = true;
    const { error, valid } = ValidateField({
      value: password.value,
      validation: password.validation,
    });
    password.touched = true;
    password.valid = valid;
    password.error = error;
    isPasswordFieldValid = isPasswordFieldValid && valid;

    if (!isPasswordFieldValid) {
      setMenuState({ ...menuState, password });
    } else {
      try {
        const result = await verifyUserPassword();
        if (result && projectToDeleteId) {
          dispatch(deleteProjectAction(projectToDeleteId, props.type)).then(
            (res) => {
              history(`/projects?project-type=${projectType}`);
            },
          );
          setConfirmPasswordOpen(false);
        }
      } catch (error) {
        setMenuState({ ...menuState, password });
      }
    }
  };
  const changeStatusHandler = () => {
    handleClose();
    if (changeStatusDialog) {
      getProjetcList();
    }
    setchangeStatusDialog(!changeStatusDialog);
  };

  const duplicateProject = async (customerId = null) => {
    const { projectId } = props;
    handleClose();
    if (customerId) {
      await dispatch(duplicateProjectAction({ projectId, customerId })).then(
        (res) => {
          getProjetcList();
          if (menuType == "View") {
            history(-1);
          }
        },
      );
    }
    if (!showDuplicateDialog) {
      let customersList = await dispatch(
        getCustomerList("business_name,first_name,name"),
      );

      customersList =
        (Array.isArray(customersList) &&
          customersList.map((customer) => {
            return {
              key: customer.businessName,
              value: customer.id,
            };
          })) ||
        [];

      setcustomersList(customersList);
    }
    setshowDuplicateDialog(!showDuplicateDialog);
  };

  const downloadMaterialSummary = () => {
    handleClose();
    dispatch(downloadMaterialSummaryAction(props.projectId));
  };

  return (
    <div>
      <Menu
        id="simple-menu"
        className={props.customstyle}
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={onClose}
      >
        {type === "PROJECT" && (
          <>
            <MenuItem
              key={"Project_Assets"}
              data-cy={"Project_Assets"}
              disabled={!writePermission}
              onClick={() => assetDialogHandler()}
            >
              Assets
            </MenuItem>
            <MenuItem
              key={"Project_Edit"}
              data-cy={"Project_Edit"}
              disabled={!writePermission}
              onClick={() => editProject()}
            >
              Edit
            </MenuItem>
            <MenuItem
              key={"Project_MarkInProgress"}
              data-cy={"Project_MarkInProgress"}
              disabled={
                entitlements.currentProject && writePermission ? false : true
              }
              onClick={() => markAsInProgress()}
            >
              Mark as In Progress
            </MenuItem>
            <MenuItem
              key={"Project_markAsDLP"}
              data-cy={"Project_markAsDLP"}
              disabled={!writePermission}
              onClick={() => markAsDLP()}
            >
              Mark as DLP
            </MenuItem>
            <MenuItem
              key={"Project_markAsCompleted"}
              data-cy={"Project_markAsCompleted"}
              disabled={!writePermission}
              onClick={() => markAsCompleted()}
            >
              Mark as Completed
            </MenuItem>
            <MenuItem
              key={"Project_markAsArchived"}
              data-cy={"Project_markAsArchived"}
              disabled={!writePermission}
              onClick={() => markAsArchived()}
            >
              Archive
            </MenuItem>
            <MenuItem
              key={"Project_deleteDialogHandler"}
              data-cy={"Project_deleteDialogHandler"}
              disabled={!writePermission}
              onClick={() => deleteDialogHandler()}
            >
              Delete
            </MenuItem>
            <MenuItem
              key={"Project_createMaterialSummary"}
              data-cy={"Project_createMaterialSummary"}
              disabled={!writePermission}
              onClick={() => downloadMaterialSummary()}
            >
              Create Material Summary
            </MenuItem>
            {props.status !== "TENDER_PENDING" && props.status !== "TENDER_SUBMITTED" && props.status !== "COSTED" && props.status !== "LOI" && (
              <MenuItem
                key={"Project_UploadCost"}
                data-cy={"Project_UploadCost"}
                disabled={!writePermission}
                onClick={() => {
                  setUploadCostOpen(true);
                }}
              >
                Upload Cost
              </MenuItem>
            )}
          </>
        )}
        {type === "TENDER" && (
          <>
            <MenuItem
              key={"Tender_handleViewProjectClose"}
              data-cy={"Tender_handleViewProjectClose"}
              disabled={
                entitlements.currentProject && writePermission ? false : true
              }
              onClick={handleViewProjectClose}
            >
              Convert to Project
            </MenuItem>
            <MenuItem
              key={"Tender_templateModalHandler"}
              data-cy={"Tender_templateModalHandler"}
              disabled={!writePermission}
              onClick={() => templateModalHandler(true)}
            >
              Create as Template
            </MenuItem>
            <MenuItem
              key={"Tender_reviseProject"}
              data-cy={"Tender_reviseProject"}
              disabled={!writePermission}
              onClick={() => reviseProject()}
            >
              New Revision
            </MenuItem>
            {props.status === PROJECT_STATUS.COSTED && (
              <MenuItem
                key={"Tender_updatePricing"}
                data-cy={"Tender_updatePricing"}
                disabled={!writePermission}
                onClick={() => updatePricing()}
              >
                Update Pricing
              </MenuItem>
            )}
            {!props.projectStepTwo && (
              <MenuItem
                key={"Tender_viewRevisions"}
                data-cy={"Tender_viewRevisions"}
                disabled={!writePermission}
                onClick={() => props.viewRevisions(props.projectId)}
              >
                View Revisions
              </MenuItem>
            )}
            <MenuItem
              key={"Tender_duplicateProject"}
              data-cy={"Tender_duplicateProject"}
              disabled={!writePermission}
              onClick={() => duplicateProject()}
            >
              Duplicate Project
            </MenuItem>
            <MenuItem
              key={"Tender_markAsSubmit"}
              data-cy={"Tender_markAsSubmit"}
              disabled={!writePermission}
              onClick={() => markAsSubmit()}
            >
              Mark as Submit
            </MenuItem>
            <MenuItem
              key={"Tender_markAsArchived"}
              data-cy={"Tender_markAsArchived"}
              disabled={!writePermission}
              onClick={() => markAsArchived()}
            >
              Archive
            </MenuItem>
            <MenuItem
              key={"Tender_deleteDialogHandler"}
              data-cy={"Tender_deleteDialogHandler"}
              disabled={!writePermission}
              onClick={() => deleteDialogHandler()}
            >
              Delete
            </MenuItem>
          </>
        )}
        {type === "DLP" && (
          <>
            <MenuItem
              key={"DLP_handleViewProjectClose"}
              data-cy={"DLP_handleViewProjectClose"}
              disabled={
                entitlements.currentProject && writePermission ? false : true
              }
              onClick={handleViewProjectClose}
            >
              Mark as Current
            </MenuItem>
            <MenuItem
              key={"DLP_markAsCompleted"}
              data-cy={"DLP_markAsCompleted"}
              disabled={!writePermission}
              onClick={() => markAsCompleted()}
            >
              Mark as Completed
            </MenuItem>
            <MenuItem
              key={"DLP_markAsArchived"}
              data-cy={"DLP_markAsArchived"}
              disabled={!writePermission}
              onClick={() => markAsArchived()}
            >
              Mark as Archived
            </MenuItem>
          </>
        )}
        {type === "COMPLETED" && (
          <>
            <MenuItem
              key={"COMPLETED_handleViewProjectClose"}
              data-cy={"COMPLETED_handleViewProjectClose"}
              disabled={
                entitlements.currentProject && writePermission ? false : true
              }
              onClick={handleViewProjectClose}
            >
              Mark as Current
            </MenuItem>
            <MenuItem
              key={"COMPLETED_markAsArchived"}
              data-cy={"COMPLETED_markAsArchived"}
              disabled={!writePermission}
              onClick={() => markAsArchived()}
            >
              Mark as Archived
            </MenuItem>
            <MenuItem
              key={"COMPLETED_markAsDLP"}
              data-cy={"COMPLETED_markAsDLP"}
              disabled={!writePermission}
              onClick={() => markAsDLP()}
            >
              Mark as DLP
            </MenuItem>
            <MenuItem
              key={"Project_createMaterialSummary"}
              data-cy={"Project_createMaterialSummary"}
              disabled={!writePermission}
              onClick={() => downloadMaterialSummary()}
            >
              Create Material Summary
            </MenuItem>
          </>
        )}
      </Menu>

      {viewProjectOpen && (
        <Modal
          open={viewProjectOpen}
          onClose={handleViewProjectClose}
          modalHeading={"Convert To Project"}
          modalSaveTxt="Convert"
          modalCloseTxt="Cancel"
          fullWidth={true}
          maxWidth={"md"}
          modalContent={
            <AddProject
              {...props}
              currentStep={0}
              tenderEditPage={true}
              projectId={projectId}
              convertTender={true}
              convertToProject={true}
              handleClose={handleViewProjectClose}
              permissions={{ writePermission: true }}
              hasAttributionEnabled={hasAttributionEnabled}
            />
          }
          primary
        />
      )}
      <AddTemplate
        templateModalHandler={templateModalHandler}
        open={showTemplateModal}
        saveTemplate={saveTemplate}
      />
      <ChangeProjectStatus
        open={changeStatusDialog}
        dialogClose={changeStatusHandler}
        changeStatus={changeStatus}
        projectId={projectId}
        newStatus={newStatus}
      />
      <DeleteDialog
        open={deleteopen}
        id={deleteId}
        deleteHandler={deleteHandler}
        dialogClose={() => {
          deleteDialogHandler();
          handleClose();
        }}
        moduleName="Project"
        description={`Project - ${props.projectName || ""}`}
      />
      <DuplicateProjectDialog
        open={showDuplicateDialog}
        dialogClose={duplicateProject}
        customersList={customersList}
      />
      <Modal
        open={confirmPasswordOpen}
        onClose={() => {
          setConfirmPasswordOpen(false);
          setMenuState({
            ...JSON.parse(JSON.stringify(projectListPasswordField)),
          });
          handleClose();
        }}
        onClick={handlePasswordVerification}
        showActionBtn
        modalHeading={"Enter Password To Confirm Deletion"}
        modalSaveTxt="Confirm"
        modalCloseTxt="Cancel"
        fullWidth={true}
        maxWidth={"md"}
      >
        <CustomInput
          {...menuState.password}
          onChange={(e) => inputPasswordChangeHandler(e)}
        />
      </Modal>

      {uploadCostOpen && (
        <UploadCostModal
          open={uploadCostOpen}
          onClose={() => {
            setUploadCostOpen(false);
            handleClose();
          }}
          projectId={projectId}
          onSaveSuccess={() => {
            if (menuType === "View") {
              dispatch(getvendorsPOInvoiceCount(projectId)).then((res) => {
                const invoicecount = res?.invoicecount || 0;
                const currentOverviewCards = projectSummary.overviewCards || {};
                dispatch(addOverviewCardsAction({
                  ...currentOverviewCards,
                  vendorInvoiceCount: invoicecount
                }));
              }).catch((err) => {
                console.error("Error refreshing vendor invoice count:", err);
              });
            }
          }}
        />
      )}
    </div>
  );
}

export default ProjectMenu;
